import getBuildConfigPrebuildRow from "../DataDisplayRow/BuildConfigPrebuildRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class BuildConfigPrebuildRowTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getBuildConfigPrebuildRow()
    }
}

let buildConfigPrebuildRowTable: BuildConfigPrebuildRowTable | null = null;

export default function getBuildConfigPrebuildTable(): BuildConfigPrebuildRowTable {
    if (buildConfigPrebuildRowTable === null)
        buildConfigPrebuildRowTable = new BuildConfigPrebuildRowTable()
    return buildConfigPrebuildRowTable
}